<template>
    <div class="bg-dark" style="height:100vh;">
        <div class="mt-4 " style="position:fixed;left:10px;">
            <router-link to="/getWord" class="btn btn-primary" style="border-radius:100%"><i class="fas fa-eye"></i></router-link></div>
        <div style="">
                <b-modal @ok="handleHeja()" id="modal-2"  class="modal-header-close" title="ویرایش هجا ها" okTitle="ثبت تغیرات" cancelTitle="انصراف">
    <div style="max-height:80vw">
        <h4>{{res.s}}</h4>
        <p class="alert alert-info">
            هجا ها را با '/' از هم جدا نمایید
        </p>
        <hr>

        <input type="text" name="" id="" :value="res.wordDetails ? res.wordDetails.join('/') : ''" @input="newHeja = $event.target.value">
    </div>
  </b-modal>
    <b-modal @ok="handleAva()" id="modal-1"  class="modal-header-close" title="ویرایش آوا ها" okTitle="ثبت تغیرات" cancelTitle="انصراف">
    
    <div style="max-height:100vw">
        <input type="text" ref="phonemesInput" :value="res.phonemes ? res.phonemes.join(' / ') : ''" @input="newPhonemes = $event.target.value" class="form-control" disabled id="">
        <hr>
        <div>
        <i class="fad fa-trash-alt text-warning " @click="removePh()" style="cursor:pointer;float:left;margin-left:10px" ></i >
<h6>  </h6> <h6>تبدیل به :</h6> 

            <div style="text-align:center" class="d-flex justify-content-center" >                 
            <div >
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> آ </p>           
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> او </p> 
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> ای </p>
            </div>
            <div>
                            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> اَ </p>   
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> اِ </p>   
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> اُ </p>    
                </div>         
                <div>
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> اَی </p>
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> اِی </p>
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> اُی </p>
                </div>
                <div>
            <p style="padding:10px;min-width:50px;background:gray;color:white;border-radius:10px" class="m-2" @click="addPh($event.target.innerText)"> آی </p>
                </div>
            </div>
                        <hr>
        </div>
    </div>
  </b-modal>
        </div>
         <div class="d-flex  justify-content-center">
            <div class="col-sm-8 col-md-5 col-lg-3">
                <div class="row justify-content-center">  <div class=" p-4" 
                            style="font-family:vazir;font-size:24pt;font-weight:600;color:cyan">رایـ<span style="color:whitesmoke">مو</span></div></div>
                <div class="card card-default" style="background:transparent;min-height:300px">
                    <div class="card-header" style="color:white;text-align:center">
                        <h5 v-if="part == 1">فرم افزودن کلمه</h5>
                        <h5 v-else>{{this.res.s}}
                            <i class="fad fa-sync-alt mt-1" style="position:absolute;left:15px;cursor:pointer" @click="removeForm()"></i>
                        </h5>
                    </div>
                    <div class="card-body" style="height:100%;position:relative" v-if="part == 1">
                        <div>
                            <div class="input-group mb-2">
                            <div class="input-group-prepend"><i class="fas fa-pen input-group-text p-1" style="color:gray;background:transparent"></i></div>
                            <input type="text" v-model="string" class="form-control text-light" style="background:transparent" placeholder="کلمه مورد نظر را وارد کنید">
                        </div>
                        <div>
                            <p class="text text-info"> <i class="fas fa-info-circle"></i> کلمه را با اِعراب وارد کنید</p>
                        </div>
                        </div>
                        <div></div>
                        <div class=" row" style="position:absolute;bottom:10px;width:85%;margin:0">
                            <button @click="wordProcess()" class="btn btn-block btn-info">ادامه</button>
                        </div>
                    </div>
                    <div class="card-body" v-if="part == 'waiting'">
                              <i class="fas fa-spinner fa-pulse " style="color:white;position:absolute;top:50%;right:48%"></i>
                    </div>
                    <div class="card-body" v-if="part == 2">

                        <div class="card m-1" style="background:transparent">
                            <div class="p-1" style="color:whitesmoke">آوا ها <span><b-button v-b-modal.modal-1 style="float:left" class="btn btn-link btn-sm">ویرایش</b-button></span></div>
                            <div class="mb-2">
                                <span  v-for="(r , index) in res.phonemes" :key="index">
                                    <span class="bg-secondary text-light mt-4 p-1 mr-1  " style="min-width:40px;font-size:10pt;border-radius:10px">{{index + 1}} . {{r}} </span>
                                </span>
                                </div> 
                        </div>
                        <div class="card m-1" style="background:transparent">
                            <div class="p-1" style="color:whitesmoke">هجا ها <span><b-button v-b-modal.modal-2 style="float:left" class="btn btn-link btn-sm">ویرایش</b-button></span></div>
                                <div class="mb-2">
                                <span  v-for="(r , index) in res.wordDetails" :key="index">
                                    <span class="bg-secondary text-light mt-4 p-1 mr-1  " style="min-width:40px;font-size:10pt;border-radius:10px">{{index + 1}} . {{r}} </span>
                                </span>
                                </div> 
                        </div>
                         <div class="mt-2">
                            <p class="text text-info x"> <i class="fas fa-info-circle"></i> در صورت اشتباه بودن آوا ها آنها را ویرایش کنید</p>
                        </div>
                        <div style="min-height:50px"></div>
                        <div class=" row" style="position:absolute;bottom:10px;width:85%;margin:0">
                            <button @click="saveWord()" class="btn btn-block btn-success">ثبت کلمه</button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {

    data(){
        return{
            part : 1,
            string:'',
            res:[],
            newPhonemes:'',
            newHeja:''
        }
    },
    
    watch:{

   

    },
    created(){
        if(this.$route.query.string){
            this.string = this.$route.query.string
            this.wordProcess()

        }
    },
    methods:{
    remove(index){
        this.phonemes.splice(index , 1)
    },

    removeForm(){
            this.res = []
            this.phonemes = []
            this.string = ''
            this.part = 1

    },
    addPh(c){
        if(this.$refs.phonemesInput.value == ''){
            this.$refs.phonemesInput.value = c
        }else{
        this.$refs.phonemesInput.value += ' / ' + c 
        }

    },

    removePh(){
        let array = this.$refs.phonemesInput.value.split(' / ')
        array.splice(array.length - 1 , 1)
         this.$refs.phonemesInput.value = array.join(' / ')
    },
    handleAva(){
            this.res.phonemes = this.$refs.phonemesInput.value.split(' / ')
    },
    handleHeja(){
        if(this.newHeja != ''){
            this.res.wordDetails = this.newHeja.split("/")
        }
    },
    async wordProcess(){
        this.part = 'waiting'
        let res = await axios.post(`http://185.81.96.220/getWordDetails?api_token=${this.$store.getters.token}` ,
        {string : this.string})
        if(res.status == 200){
            this.res = res.data
            this.phonemes = res.data.phonemes
            this.part = 2
        }
    },
        async saveWord(){
        this.part = 'waiting'
        let res = await axios.post(`http://185.81.96.220/saveWord?api_token=${this.$store.getters.token}` ,
        {
            word : this.res
        })
        if(res.status == 200){
            this.res = []
            this.phonemes = []
            this.string=''
            this.part = 1
            this.$notify({
            group: 'word-add',
            title: 'با تشکر',
            type:'success',
            text: res.data
            });
        }else{
            this.res = []
            this.phonemes = []
            this.string=''
            this.part = 1
            this.$notify({
            group: 'word-add',
            title: 'خطا',
            type:'danger',
            text: res.data
            });
        }
    }
    },

}
       //      test2(){
            
        //     // let search = true
        //     let string = this.test
        //     let array = []
        //     let num = 0
        //     let forward = null
        //     for(var i = 0 ; i < string.length ; i++){
        //     let char = this.checkChar(string)//Mosavete badi
        //        num = string.search(char)
        //        //in if check mikone age ham mosavet bood ham roosh harekat bood mosaveto rad kone harekato hesab kone
        //         if(string[num + 1] == 'ا'  || string[num + 1] == String.fromCharCode(1614)|| string[num + 1] == String.fromCharCode(1615)|| string[num + 1] == String.fromCharCode(1616)){  
        //             forward = string[num] // inja miad oon harfio ke rad mikone save mikone ke akhar bezare avale heja
        //             num = num + 1

        //            }
        //        if(string[num + 2] == 'ا' || string[num + 2] == 'ی' || string[num + 2] == 'و' || string[num + 2] == String.fromCharCode(1614)|| string[num + 2] == String.fromCharCode(1615)|| string[num + 2] == String.fromCharCode(1616) ){
        //         if(string[num + 3] == 'ا' || string[num + 3] == 'ی' || string[num + 3] == 'و' || string[num + 3] == String.fromCharCode(1614)|| string[num + 3] == String.fromCharCode(1615)|| string[num + 3] == String.fromCharCode(1616) ){
        //         let heja = string.slice(0,num + 2) 
        //         array.push(heja)
        //         string = string.slice(num + 2,string.length)
        //         forward = null
        //            }
        //         else{               
        //         let heja = forward ? string.slice(0,num + 1) : string.slice(0,num + 1) 
        //         array.push(heja)
        //         string = string.slice(num + 1,string.length )
        //         forward = null
        //         }
        //        }else{
        //         //inja check mishe age to ife aval forward dashte bashim behesh ezafe kone

        //         let heja = forward ? string.slice(0,num + 2) : string.slice(0,num + 2) 

        //         array.push(heja)
        //         string = forward ? string.slice(num + 2,string.length) : string.slice(num + 2,string.length)
        //         forward = null

        //        }


             

        //     }               
        // if(string != ""){
        //     console.log(string)
        //     if(array[array.length - 1].length <= 3 && string.length < 2){

        //         array[array.length - 1] += string[0]
        //         string.slice(string[0] , string[1])
        //     }else{
        //         array.push(string)
        //     }

        // }
        // this.res = array

 
                          

        // },
</script>
<style scoped>
.fa-sync-alt:hover{
transition: cubic-bezier(0.68, -0.55, 0.265, 1.55) 1s;
transform: rotate(180deg)
}
.btn{
    color:white!important
}

</style>